import React, { Component } from 'react';
import OwnerDashboard from './OwnerDashboard';

export default class OwnerDashboardPage extends Component {
  render () {
    return (
      <div className="c-owner-dashboard-page">
        <OwnerDashboard/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/OwnerDashboardPage.js